import { createRouter, createWebHistory } from 'vue-router';
import { getGlobalHandle } from '@getaccept/lib-shared-new/src/helpers';
import Segment from '@getaccept/lib-shared-new/src/segment';
import type { Language } from '@getaccept/lib-shared-new/src/languages/enums/language';
import CreateEntity from './create-entity/components/CreateEntity.vue';
import { Hubspot } from './services/hubspot.service';
import VerifyUser from './verify-user/components/VerifyUser.vue';
import Signup from './signup/components/Signup.vue';
import SignupTemplateViewer from './signup-template-viewer/components/SignupTemplateViewer.vue';
import { userLanguage } from './helpers/language';
import { useLanguageStore } from './language/store/language.store';

const signupBeforeEnter = (_to, _from, next) => {
  Hubspot.initialize();
  next();
};

const router = createRouter({
  history: createWebHistory(getGlobalHandle()._basePath || '/'),
  routes: [
    {
      path: '/signup/template/:templateId',
      component: SignupTemplateViewer,
      props: true,
    },
    {
      path: '/signup',
      component: Signup,
      name: 'signup',
      meta: {
        title: 'Signup',
      },
      props: ({ query: { ref, email } }) => ({
        registrationCampaignId: ref,
        registrationEmail: email,
      }),
      beforeEnter: signupBeforeEnter,
    },
    {
      path: '/signup/create-entity/:id?',
      name: 'create-entity-signup',
      meta: {
        title: 'Create company',
      },
      component: CreateEntity,
      props: route => {
        const { id: userId } = route.params;
        const { entityName, entityCountryCode } = route.query;
        return {
          isSignup: true,
          userId,
          entityName,
          entityCountryCode,
        };
      },
    },
    {
      path: '/create-entity/:id?',
      name: 'create-entity',
      meta: {
        title: 'Create company',
      },
      component: CreateEntity,
      props: () => ({
        isSignup: false,
      }),
    },
    {
      path: '/signup/:id/:key',
      component: VerifyUser,
      name: 'verify-user',
      meta: {
        title: 'Create user',
      },
      props: route => {
        const { id: signupId, key: signupKey } = route.params;
        const { firstName, lastName, isInvitation } = route.query;
        return {
          signupId,
          signupKey,
          firstName,
          lastName,
          isInvitation: isInvitation === 'true',
        };
      },
    },
  ],
});

router.beforeEach((to, _from, next) => {
  const languageStore = useLanguageStore();
  const language = to.query.lang || userLanguage();
  languageStore.setLanguage(language as Language);

  if (to.meta.title) {
    document.title = `${to.meta.title} | GetAccept`;
    return next();
  }

  Hubspot.trackPageView(to.path);
  Segment.page('Signup', to.meta?.title as string);

  document.title = `GetAccept`;
  next();
});

export default router;
